import * as React from "react";
import { path } from "ramda";
import { Link, useLocation } from "react-router-dom";
// Shared components
import Maybe from "components/Maybe";
// Utilities and hooks
import useUser from "hooks/useUser";
// Local components
import Main from "screens/Auth/components/Main";
import ExternalLinks from "screens/Auth/components/ExternalLinks";
import RegisterForm from "screens/Auth/screens/Activate/components/RegisterForm";
// UI frameworks
import { Result, Spin } from "antd";

const Activate: React.FC = () => {
	// @ts-ignore
	const { query } = useLocation();
	// @ts-ignore
	const { verifyEmailActivationCode } = useUser();
	const [loading, setLoading] = React.useState(true);
	const [isSuccess, setIsSuccess] = React.useState(false);

	React.useEffect(() => {
		const verifyKey = async () => {
			if (path(["key"])(query)) {
				try {
					setLoading(true);
					const res = await verifyEmailActivationCode(query.key);
					if (res) {
						setIsSuccess(true);
						setLoading(false);
					} else {
						setLoading(false);
						setIsSuccess(false);
					}
				} catch (error) {
					setLoading(false);
					setIsSuccess(false);
				}
			} else {
				setLoading(false);
			}
		};
		verifyKey();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [query]);

	return (
		<React.Fragment>
			<Maybe condition={loading}>
				<Main title="فعالسازی حساب کاربری" subTitle="فعالسازی حساب کاربری">
					<div className="text-center mb-20">
						<Spin size="large" />
						<h4 className="mt-20">در حال اعتبارسنجی...</h4>
					</div>
				</Main>
			</Maybe>
			<Maybe condition={!loading && !isSuccess}>
				<Main title="فعالسازی حساب کاربری" subTitle="فعالسازی حساب کاربری">
					<Result
						status="error"
						title="پارامتر های ارسالی نامعتبر است."
						extra={[
							<Link to="/auth/register" key="failReport" className="ant-btn">
								بازگشت به صفحه ثبت نام
							</Link>,
						]}
					/>
				</Main>
			</Maybe>
			<Maybe condition={!loading && isSuccess}>
				<Main title="فعالسازی حساب کاربری" subTitle="فعالسازی حساب کاربری">
					<RegisterForm />
					<ExternalLinks login />
				</Main>
			</Maybe>
		</React.Fragment>
	);
};

export default React.memo(Activate);
